<script setup>
import { computed } from 'vue'

import { CHECKIN_ENTITY_KEYS } from '@/utils/entity-keys'
import { calculateObjectiveStatus } from '@/utils/objectives'
import { OKR_ELEMENT_KEYS } from '@/utils/view-row-actions'

import ObjectiveStatus from '@/components/objectives/ObjectiveStatus'

defineOptions({
  name: 'CheckinChangedStatus',
  inheritAttrs: false
})

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})

const status = computed(() => {
  return calculateObjectiveStatus(
    props.data[CHECKIN_ENTITY_KEYS.VALUE],
    props.data[OKR_ELEMENT_KEYS.AUTOMATIC_CONFIDENCE_LEVEL_ID]
  )
})

const styles = computed(() => {
  if (props.data[CHECKIN_ENTITY_KEYS.OUTDATED]) {
    return {
      color: 'var(--grey-1-next)',
      '--rgb-color': 'var(--grey-1-next-rgb)'
    }
  }

  return {}
})

const testId = computed(() => {
  return `${props.data[CHECKIN_ENTITY_KEYS.OUTDATED] ? 'old' : 'new'}-status`
})
</script>

<template>
  <ObjectiveStatus
    :class="{
      'cc-Status-outdated': data[CHECKIN_ENTITY_KEYS.OUTDATED]
    }"
    :data-auto-testid="testId"
    :data-testid="testId"
    :status="status"
    :style="styles"
    class="cc-Status"
  />
</template>

<style lang="scss" scoped>
.cc-Status {
  --os-font-size: #{$fs-10};
}
</style>
